import { render, staticRenderFns } from "./SearchResultHeader.vue?vue&type=template&id=1c492e5b&scoped=true&"
import script from "./SearchResultHeader.vue?vue&type=script&lang=js&"
export * from "./SearchResultHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultHeader.vue?vue&type=style&index=0&id=1c492e5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c492e5b",
  null
  
)

export default component.exports